import React, {Component} from 'react';
import {Button, Container, Divider, Form, Header, Message, Segment} from "semantic-ui-react";
import Footer from "./footer";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import {CustomEmailInput, CustomGrid} from './custom-common';
import {UnsubscribeRequest} from "../services/types";
import {unsubscribe} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const {initialData} = state;
    return {
        ...ownProps,
        token: initialData.token,
        tokenEmail: initialData.email,
    }
};

class Unsubscribe extends Component {
    constructor(props) {
        super(props);
        this.state={
            loading: false,
            error: false,
            email: props.tokenEmail,
        }
    }

    handleSubmit = async () => {
        const handleError = () =>{
            this.setState({loading: false, error: true});
        }
        try {
            this.setState({loading: true, error: false});
            const {email} = this.state;
            const {token} = this.props;
            const request = new UnsubscribeRequest({email, token});
            let result = await unsubscribe(request);
            if (result.status === 200) {
                this.setState({
                    loading: false,
                })
                window.onbeforeunload = null;
                this.props.history.push("/unsubscribeSuccess");
            } else {
                handleError();
            }
        }catch(e){
            console.log(e);
            handleError();
        }
    }

    render() {
        const {email, error, loading} = this.state;
        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <CustomGrid container stackable columns={1} centered>
                        <CustomGrid.Column style={{maxWidth: '420px'}}>
                            <Segment style={{padding: '48px'}}>
                                <Header as="h3">Unsubscribe</Header>
                                <b>We're sorry to see you go.</b><br/>
                                <small>Please confirm the email address you want to unsubscribe—</small>
                                <Divider hidden/>
                                <Form>
                                    <CustomEmailInput
                                        value={!!email? email: ''}
                                        onChange={(e, {value})=>{
                                            this.setState({email: value, error: false});
                                        }}
                                    />
                                    <Button primary
                                            loading={loading}
                                            onClick={this.handleSubmit}
                                            disabled={email === null || email.length === 0 || loading}>
                                        Unsubscribe
                                    </Button>
                                </Form>
                                <Divider hidden/>
                                {error && <Message error={true}>There was an error unsubscribing the specified email address</Message>}
                                <p>
                                    <b>Note: </b>By clicking unsubscribe you are opting out of marketing emails.
                                    You will still receive service emails related to your {STRATEGIC_PARTNER.LABEL} account and coverage.
                                </p>
                            </Segment>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>

                <Footer showTopFooter={false} showCenterData={true}/>
            </React.Fragment>
        );
    }
}

export default withRouter(connect(mapStateToProps)(Unsubscribe));